export const TOKEN = 'token';
export const USER_ID = 'userId';
export const USER_TYPE = 'userType';
export const LOCALE = 'locale';
